import { render } from "./router-tab.vue?vue&type=template&id=1d59f8a4"
import script from "./router-tab.vue?vue&type=script&lang=js"
export * from "./router-tab.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__